import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import { NavigationService } from '@services/nav/nav.service';
import { TestHooks } from './back-to-integrations-button.hooks';

@Component({
	selector: 'app-back-to-integrations-button',
	templateUrl: './back-to-integrations-button.component.html',
	styleUrls: ['./back-to-integrations-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class BackToIntegrationsButtonComponent {
	testHooks = TestHooks;
	public ICON = ICON;

	constructor(private navService: NavigationService) {}

	goToIntegrations(): void {
		this.navService.goToProfile_Integrations();
	}
}
